import { FormValues } from '@features/users/adminPanel/components/Form/Form.types.ts';
import { apiRoutes } from '@features/users/adminPanel/consts/apiRoutes.ts';
import { transformAdvertiserInsertionOrdersResponseDTO } from '@features/users/adminPanel/services/advertiserInsertionOrders/service.dto.ts';
import { AdvertiserInsertionOrderCollection } from '@features/users/adminPanel/services/advertiserInsertionOrders/service.types.ts';
import { AdvertisersCollection } from '@features/users/adminPanel/types/advertisers.types.ts';
import { apiClient } from '@shared/api/ApiClient.ts';
import { MsGraphApiResponse } from '@shared/api/commonApiInterfaces.ts';

export async function getAdvertiserInsertionOrders(): Promise<AdvertisersCollection | null> {
  return await apiClient
    .get<MsGraphApiResponse<AdvertiserInsertionOrderCollection>>(apiRoutes.getAdvertiserInsertionOrders())
    .then((response) => {
      if (!response?.items) {
        return null;
      }

      return transformAdvertiserInsertionOrdersResponseDTO(response.items);
    });
}

export async function postAdvertiserInsertionOrder(payload: FormValues) {
  return await apiClient.post(apiRoutes.postAdvertiserInsertionOrder(), payload);
}

export async function putAdvertiserInsertionOrder(id: string, payload: FormValues) {
  return await apiClient.put(apiRoutes.putAdvertiserInsertionOrder(id), payload);
}
